import { Button, message, Upload, UploadProps } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { UploadFile } from "antd/lib/upload/interface";
import { useDispatch, useSelector } from "react-redux";
import { request } from '../../../../shared/src/apis';
import { uploadUserSlipsApi } from "../../utils/apisConsts";
import { errorMessage } from "../../utils/commonStringsConsts";
import { stepperMoving } from "../../stores/actions";


function UploadPaymentSlipsForm() {
    const MAX_FILES = 4;
    const MAX_FILE_SIZE_MB = 20;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
    let limitWarningShown = false;
    let fileSizeWarningShown = false;
    const dispatch = useDispatch();
    const paymentSlips = useSelector((state: any) => state.actionsReducer.info)?.paymentSlips;
    const additionalDocuments = useSelector((state: any) => state.actionsReducer.info)?.additionalDocuments;
    const userID = useSelector((state: any) => state.actionsReducer.info)?.userID;
    const [isLoading, setIsLoading] = useState(false);
    const [paymentSlipsFiles, setPaymentSlipsFiles] = useState<UploadFile[]>([]);
    const [additionalDocsFiles, setAdditionalDocsFiles] = useState<UploadFile[]>([]);

    useEffect(() => {
        if (paymentSlips && paymentSlips?.length > 0) {
            const files = paymentSlips?.map((file: {id:number,url:string}) => ({
                ...file,
                name: file?.url?.split('/').pop(),
            }));
            setPaymentSlipsFiles(files);
        }
    }, [paymentSlips])

    useEffect(() => {
        if (additionalDocuments && additionalDocuments?.length > 0) {
            const files = additionalDocuments?.map((file: {id:number,url:string}) => ({
                ...file,
                name: file?.url?.split('/').pop(),
            }));
            setAdditionalDocsFiles(files);
        }
    }, [additionalDocuments])

    const paymentSlipsProps: UploadProps = {
        name: 'uploadPaymentSlips',
        accept: ".pdf,.jpg,.jpeg,.png",
        multiple: true,
        fileList: paymentSlipsFiles,
        onChange: (info) => handleUploadChange(info, setPaymentSlipsFiles),
        beforeUpload: (file, fileList) => {
            const totalCount = paymentSlipsFiles?.length + fileList.length;
            if (!/\.(|pdf|jpg|jpeg|png)$/i.test(file.name)) {
                message.warning(`The extension of ${file.name} is not supported!`);
                return Upload.LIST_IGNORE;
            }
            if (file.size > MAX_FILE_SIZE_BYTES) {
                if (!fileSizeWarningShown) {
                    message.warning(`Max File Size should be ${MAX_FILE_SIZE_MB}MB limit.`);
                    fileSizeWarningShown = true;
                    setTimeout(() => (fileSizeWarningShown = false), 500);
                }
                return Upload.LIST_IGNORE;
            }
            if (totalCount > MAX_FILES) {
                if (!limitWarningShown) {
                    message.warning(`You can only upload up to ${MAX_FILES} files.`);
                    limitWarningShown = true;
                    setTimeout(() => {
                        limitWarningShown = false;
                    }, 500);
                }
                return Upload.LIST_IGNORE;
            }

            return true;
        },

    };

    const additionalDocsProps: UploadProps = {
        name: 'uploadAdditionalDocs',
        accept: ".pdf,.jpg,.jpeg,.png",
        multiple: true,
        fileList: additionalDocsFiles,
        onChange: (info) => handleUploadChange(info, setAdditionalDocsFiles),
        beforeUpload: (file, fileList) => {
            const totalCount = additionalDocsFiles?.length + fileList?.length;
            if (!/\.(|pdf|jpg|jpeg|png)$/i.test(file.name)) {
                message.warning(`The extension of ${file.name} is not supported!`);
                return Upload.LIST_IGNORE;
            }
            if (file.size > MAX_FILE_SIZE_BYTES) {
                if (!fileSizeWarningShown) {
                    message.warning(`Max file size should be ${MAX_FILE_SIZE_MB}MB limit.`);
                    fileSizeWarningShown = true;
                    setTimeout(() => (fileSizeWarningShown = false), 500);
                }
                return Upload.LIST_IGNORE;
            }
            if (totalCount > MAX_FILES) {
                if (!limitWarningShown) {
                    message.warning(`You can only upload up to ${MAX_FILES} files.`);
                    limitWarningShown = true;
                    setTimeout(() => {
                        limitWarningShown = false;
                    }, 500);
                }
                return Upload.LIST_IGNORE;
            }

            return true;
        },
    };

    const handleUploadChange = (
        info: any,
        setFileList: React.Dispatch<React.SetStateAction<UploadFile[]>>
    ) => {
        const { fileList } = info;
        const updatedList = fileList
            .map((file: any) => {
            if (!file.url && file.originFileObj) {
                file.url = URL.createObjectURL(file.originFileObj);
            }
            return file;
            })
            .filter((file: any) => file?.status);

        setFileList(updatedList);
    };


    const handleSubmit = async () => {
        const formData = new FormData();
        paymentSlipsFiles?.forEach((file) => {
            if (file.originFileObj) {
                formData.append('paymentSlips', file.originFileObj);
            }
        });
        additionalDocsFiles?.forEach((file) => {
            if (file.originFileObj) {
                formData.append('additionalDocuments', file.originFileObj);
            }
        });
        if (!formData.has('paymentSlips') && !formData.has('additionalDocuments')) {
            message.error('Replace the deleted documents with at least one.')
            return;
        }
        formData.append('userID', userID);
        setIsLoading(true);
        try {
            const apiData: any = await dispatch(request({ method: 'PATCH', url: uploadUserSlipsApi, data: formData }))
            const res = await apiData?.data;
            if (res?.status === 200) {
                setIsLoading(false);
                dispatch(stepperMoving(0));
                message.success(res?.message, 6);
                return
            }
            message.error(res.message);
            setIsLoading(false);
        } catch (error) {
            message.error(errorMessage);
            setIsLoading(false);
        }
    }

    return (
        <>
                <Upload
                    {...paymentSlipsProps}
                    customRequest={({ file, onSuccess }) => {
                        setTimeout(() => {
                            if (onSuccess) {
                                onSuccess("ok", file as any);
                            }
                        }, 1000)
                    }}
                    fileList={paymentSlipsFiles}
                    listType="picture"
                >
                    <Button icon={<UploadOutlined />} style={{ margin: '40px 0 15px', padding: '3px 10px' }}>Upload Payment slips</Button>
                </Upload>

                <Upload
                    {...additionalDocsProps}
                    customRequest={({ file, onSuccess }) => {
                        setTimeout(() => {
                            if (onSuccess) {
                                onSuccess("ok", file as any);
                            }
                        }, 1000)
                    }}
                    fileList={additionalDocsFiles}
                    listType="picture"
                >
                    <Button icon={<UploadOutlined />} style={{ margin: `${paymentSlipsFiles?.length > 0 ? '40px' : '10px'} 0 15px`, padding: '3px 10px' }} >Upload Additional Documents</Button>
                </Upload>
            
            <div className="flex justify-end">

                <Button htmlType="submit" onClick={handleSubmit} type="primary" className="mt-8" loading={isLoading} disabled={isLoading}>Submit</Button>

            </div>
        </>



    )
}

export default UploadPaymentSlipsForm;